import React from 'react'
import { useIntl } from 'react-intl'
import {
  FormElement,
  InputText,
  INPUT_TEXT_VARIANT_DANGER
} from 'mailup-web-components'
import { useRecoilState } from 'recoil'
import { pageState } from '../recoil/state/page'
import { getExtension, URL_REGEX } from '../const'

const InputUrl = () => {
  const intl = useIntl()
  const [{ url, isUrlDirty, warning }, setUrlState] = useRecoilState(pageState)

  const handleChange = e => {
    e.stopPropagation()
    e.preventDefault()
    const value = e.target.value
    setUrlState(prev => ({
      ...prev,
      url: value,
      isUrlDirty: true,
      isDirty: true,
      extension: getExtension(value)
    }))
  }

  const getFeedback = () => {
    if (url.trim().length === 0 && isUrlDirty) {
      return intl.formatMessage({ id: 'Load.MailupCommon.Required' })
    } else if (url.trim().length > 0 && isUrlDirty && !url.match(URL_REGEX)) {
      return intl.formatMessage({ id: 'Load.UrlTrackMap.UrlIsNotValid' })
    }
    return undefined
  }

  const getVariant = () => {
    if (url.trim().length === 0 && isUrlDirty) {
      return INPUT_TEXT_VARIANT_DANGER
    } else if (url.trim().length > 0 && isUrlDirty && !url.match(URL_REGEX)) {
      return INPUT_TEXT_VARIANT_DANGER
    }
    return undefined
  }

  return (
    <FormElement
      required
      labelFor='inputUrl'
      label={intl.formatMessage({
        id: 'Load.EmailMessageImport.ImportUrlLabel'
      })}
      feedback={getFeedback()}
    >
      <InputText
        disabled={warning}
        onChange={handleChange}
        value={url}
        data-mu-test='input-url'
        variant={getVariant()}
      />
    </FormElement>
  )
}

export default InputUrl
